export default __webpack_public_path__ + "static/media/Add-Device.c38f2b87.png";